import script from "./AccountDeletionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDeletionDialog.vue?vue&type=script&setup=true&lang=js"

import "./AccountDeletionDialog.vue?vue&type=style&index=0&id=69b5de47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b5de47"]])

export default __exports__